import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router';

interface ErrorDisplayProps {
  error: string;
  retryAction?: () => void;
  backRoute?: string;
  backLabel?: string;
}

/**
 * A reusable error display component with retry and back navigation options
 */
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  retryAction,
  backRoute = '/campaigns',
  backLabel = 'Back to Campaigns',
}) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mt: 3 }}>
      <Alert severity="error">{error}</Alert>
      <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
        {retryAction && (
          <Button variant="contained" onClick={retryAction}>
            Retry
          </Button>
        )}
        <Button variant="outlined" onClick={() => navigate(backRoute)}>
          {backLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorDisplay;
